import { SnackTypeEnum } from "./snackbar.enum";

export class SnackbarOptions {
  constructor(
    public type: string = SnackTypeEnum.ERROR,
    public message: string = 'SCREEN_PRECHECKIN_SNACKBAR.ERROR_DEFAULT_MESSAGE',
    public size: string | null = null,
    public duration: number = 3500,
  ) {}
}